import type { ReactElement } from 'react';
import { Outlet } from 'react-router-dom';
import { AuthGuard } from '../components/auth-guard.tsx';
import { PosthogProvider } from '../components/providers/posthog-provider.tsx';
import { SentryProvider } from '../components/providers/sentry-provider.tsx';
import { VoiceRecordingProvider } from '../lib/contexts/voice-recording-context.tsx';

export function AuthenticatedLayout(): ReactElement {
    return (
        <AuthGuard>
            <PosthogProvider>
                <SentryProvider>
                    <VoiceRecordingProvider>
                        <Outlet />
                    </VoiceRecordingProvider>
                </SentryProvider>
            </PosthogProvider>
        </AuthGuard>
    );
}
